<template>
    <div v-if="show" class="mask">
        <div  class="form-modal doc-edit-modal flex flex-col flex-space-between book">
            <div class="flex flex-space-between flex-center-cz title border-box">
                <div class="margin-left-l font-s">回答</div>
                <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="close"/>
            </div>
            
            <div class="flex flex-col body padding-top-l border-box " style="height: calc(100% - 100px)" >
                <div class="flex flex-col margin-top-m">
 
                    <div class="flex flex-center-cz  edit-area margin-top-m font-m">
                        <div class="label">结果</div>
                        <div class="value"> <textarea placeholder="填写结果"  style="height: 50px;" class="ui-input full-width"  v-model="formData.result" ></textarea>   </div>
                    </div>
                        
                </div>
            </div>
            <div class="flex flex-center-sp flex-center-cz toolbar border-box"> 
                <div class="margin-right-s ui-print-button flex flex-center-cz flex-center-sp" @click="confirm">确定</div>         
            </div>
        </div>
    </div>
</template>

<script>
    import MySelect from '@/components/select/Select' 
    import { objToStr } from '../../utils/sysUtils';
    import XSelect from '@/components/xSelect/XSelect.vue';
   

    export default {
        name:'AnswerQuestionModal',
        created() {
        },
        components:{MySelect,XSelect},
        data() {
            return {
                show: null,
                formData:{},                 
                userName : sessionStorage.getItem("realname"),
                userId : sessionStorage.getItem("userId"),

            }
        },
        methods:{
            showForm(data) {
                this.formData = data;
                console.log("data====",data)
                this.show = true;        
            },
            confirm() {
                if (objToStr(this.formData.result) ==="") {
                    this.$showToast({
                        msg: '结果未填写' 
                    }) 
                    return false;
                }
                this.$emit("confirm", this.formData)
                
            },
            close() {
                this.show = false;
            },

        }
   }
</script>

<style scoped>

    .form-modal {
        top: 100px;
    }
    .doc-edit-modal {
        width: 650px;
        height: 250px;
    }
    .edit-area {
       width: 600px;
    }
 

    .body .row {
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/plugs/AnswerQuestionModal.vue